module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.f1a22f6f.ttf";